var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { API } from './api';
import { Injectable } from '@angular/core';
import { BaseProvider } from './base';
import { ClassProvider } from './class';
import { FrameProvider } from './frame';
import { TranslateService } from '@ngx-translate/core';
var InferenceProvider = /** @class */ (function (_super) {
    __extends(InferenceProvider, _super);
    function InferenceProvider(api, classProvider, frameProvider, translate) {
        var _this = _super.call(this) || this;
        _this.api = api;
        _this.classProvider = classProvider;
        _this.frameProvider = frameProvider;
        _this.translate = translate;
        return _this;
    }
    InferenceProvider.prototype.getPredictionStars = function (confidence) {
        if (confidence >= 0.8) {
            return 5;
        }
        else if (confidence >= 0.6) {
            return 4;
        }
        else if (confidence >= 0.4) {
            return 3;
        }
        else if (confidence >= 0.2) {
            return 2;
        }
        else if (confidence >= 0.01) {
            return 1;
        }
        else {
            return 0;
        }
    };
    /**
     * One issue with mouse events is that they only fire for the element with the highest z-index.
     * Since we can have an arbitrary amount of overlapping detection predictions, we need a different method
     * in order to get all the predictions that might be under the user's cursor! We tag these with our own
     * custom attribute to make locating them easier
     */
    InferenceProvider.prototype.getMouseOverPredictions = function (event, predictions) {
        var indicesUnderCursor = this.getIndicesUnderCursor(event);
        var currentlyHovered = [];
        // Iterate through each prediction under our cursor, and add it to the list of "moused over" predictions.
        indicesUnderCursor.forEach(function (index) {
            if (predictions[index]) {
                currentlyHovered.push(predictions[index]);
            }
        });
        // Sorting here simplifies the logic in the detection predictions component.
        currentlyHovered.sort(function (a, b) {
            return b.confidence - a.confidence;
        });
        return currentlyHovered;
    };
    /**
     * Consume the metadata we attached to each path in order to get the index of each prediction we found
     */
    InferenceProvider.prototype.getIndicesUnderCursor = function (event) {
        var objectsUnderCursor = document
            .elementsFromPoint(event.x, event.y)
            .filter(function (element) { return element.hasAttribute('neurala:index'); });
        // Get the prediction indexes we need to reference.
        if (objectsUnderCursor.length > 0) {
            var indexesUnderCursor_1 = [];
            objectsUnderCursor.forEach(function (element) {
                var index = element.getAttribute('neurala:index');
                if (index !== null) {
                    indexesUnderCursor_1.push(parseInt(index, 10));
                }
            });
            return indexesUnderCursor_1;
        }
        else {
            return [];
        }
    };
    InferenceProvider.prototype.getDetectionValidationFrameDetails = function (datasetIdentifier, assetIdentifier, isTestSet) {
        if (isTestSet === void 0) { isTestSet = false; }
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var results, classMap;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.frameProvider.getDetectionFrameDetail(datasetIdentifier, assetIdentifier, isTestSet)];
                    case 1:
                        results = _a.sent();
                        classMap = this.classProvider.getDatasetClassNameMap(datasetIdentifier);
                        return [2 /*return*/, {
                                name: results.name,
                                thumbSignedUrl: results.thumbSignedUrl,
                                signedUrl: results.signedUrl,
                                groundTruths: results.groundTruths.map(function (gt) {
                                    return {
                                        x1: gt.x1,
                                        y1: gt.y1,
                                        x2: gt.x2,
                                        y2: gt.y2,
                                        classObject: classMap[gt.className] ||
                                            _this.classProvider.getFallbackClassObj(gt.className, datasetIdentifier)
                                    };
                                }),
                                predictions: results.predictions.map(function (p) {
                                    return {
                                        x1: p.x1,
                                        y1: p.y1,
                                        x2: p.x2,
                                        y2: p.y2,
                                        classObject: classMap[p.className] || _this.classProvider.getFallbackClassObj(p.className, datasetIdentifier),
                                        confidence: p.confidence
                                    };
                                })
                            }];
                }
            });
        });
    };
    InferenceProvider.prototype.getDetectionSVGOverlays = function (boxes, width, height) {
        if (!boxes) {
            return [];
        }
        return boxes.map(function (box, index) {
            // Generate coordinate pairs for our SVG markup.
            var topLeft = [box.x1, box.y1];
            var topRight = [box.x2, box.y1];
            var bottomRight = [box.x2, box.y2];
            var bottomLeft = [box.x1, box.y2];
            return {
                index: index,
                color: box.classObject.color,
                classID: box.classObject.id,
                opacity: '100%',
                display: 'inline',
                path: "M " + width * topLeft[0] + " " + height * topLeft[1] + "\n                    L " + width * topRight[0] + " " + height * topRight[1] + "\n                    " + width * bottomRight[0] + " " + height * bottomRight[1] + "\n                    " + width * bottomLeft[0] + " " + height * bottomLeft[1] + "\n                    z"
            };
        });
    };
    /**
     * Iterate through each prediction or ground truth box and update the display and opacity properties.
     */
    InferenceProvider.prototype.applyVisibilityInfoToSvgOverlays = function (svgOverlays, visibilityInfo) {
        svgOverlays.forEach(function (box) {
            if (visibilityInfo) {
                var classObject = visibilityInfo.find(function (control) {
                    return box.classID === control.classID;
                });
                if (classObject) {
                    box.opacity = classObject.opacity + "%";
                    box.display = classObject.visible ? 'inline' : 'none';
                }
            }
        });
    };
    InferenceProvider.prototype.getClassControls = function (boxes) {
        var classControls = new Map();
        boxes.forEach(function (box) {
            if (!classControls.get(box.classObject.id)) {
                classControls.set(box.classObject.id, {
                    id: box.classObject.id,
                    name: box.classObject.name,
                    color: box.classObject.color,
                    count: 1,
                    visible: true,
                    opacity: 100,
                    showOpacityControl: false
                });
            }
            else {
                var control = classControls.get(box.classObject.id);
                control.count += 1;
                classControls.set(box.classObject.id, control);
            }
        });
        return Array.from(classControls.values());
    };
    InferenceProvider.prototype.getDetectionVisibilityInfo = function (classControls) {
        return classControls.map(function (control) {
            return {
                classID: control.id,
                visible: control.visible,
                opacity: control.opacity
            };
        });
    };
    InferenceProvider.prototype.getDetectionVisibilityIcon = function (classControls, controlID) {
        var controlIndex = this.getDetectionControlToChange(classControls, controlID);
        if (controlIndex > -1) {
            return classControls[controlIndex].visible ? 'visibility' : 'visibility_off';
        }
        return '';
    };
    /**
     * Hide all controls but the provided exception
     * This is used to allow us to open one control and automatically hide all others
     */
    InferenceProvider.prototype.hideOtherOpacityControls = function (classControls, exceptControlId) {
        classControls.forEach(function (control) {
            if (control.id == exceptControlId) {
                return;
            }
            control.showOpacityControl = false;
        });
    };
    /**
     * Get the index of the class control whose property we want to modify
     */
    InferenceProvider.prototype.getDetectionControlToChange = function (classControls, controlID) {
        return classControls.findIndex(function (control) { return control.id === controlID; });
    };
    InferenceProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API,
            ClassProvider,
            FrameProvider,
            TranslateService])
    ], InferenceProvider);
    return InferenceProvider;
}(BaseProvider));
export { InferenceProvider };
//# sourceMappingURL=inference.js.map


// WEBPACK FOOTER //
// ./src/providers/inference.ts.pre-build-optimizer.js